export function compileSvgString(svgTemplate) {
    var _a;
    try {
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(svgTemplate, 'image/svg+xml');
        const parseError = svgDoc.querySelector('parsererror');
        if (parseError) {
            // eslint-disable-next-line no-console
            console.error('Invalid SVG:', parseError.textContent);
            return {
                success: false,
                error: parseError.textContent || 'Invalid SVG template',
            };
        }
        const compiledSvg = btoa(svgTemplate);
        return {
            success: true,
            compiledSvg,
        };
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error parsing SVG:', error);
        const err = error;
        return {
            success: false,
            error: (_a = err === null || err === void 0 ? void 0 : err.message) !== null && _a !== void 0 ? _a : 'Unknown error',
        };
    }
}
